import React, { useEffect, useContext, useState } from "react";
import { useNavigate } from "react-router-dom";
import { verifyMagicLink, setToken } from "../../lib/magic";
import { UserContext } from "../../lib/UserContext";
import Loading from "../loading/Loading";
import { getCurrentUser, updateUserScore } from "../../store/user";
import ProgressContext from "../../lib/ProgressContext";
import { Typography } from "antd";

const { Title } = Typography;

function AuthVerify({ checkCurrentLevel }) {
  const navigate = useNavigate();
  const [, setUser] = useContext(UserContext);
  const [progress, setProgress] = useContext(ProgressContext);
  const [error, setError] = useState(null);

  const getCommonScore = () => {
    let scoreCommon = 0;
    progress.forEach((element) => {
      scoreCommon += element.score;
    });
    return scoreCommon;
  };

  useEffect(() => {
    const token = new URLSearchParams(window.location.search).get("token");
    if (!token) {
      navigate("/login");
      return;
    }
    verifyToken(token);
  }, []);

  const verifyToken = async (token) => {
    try {
      const data = await verifyMagicLink(token);
      setToken(data.token);

      // Now fetch user data
      const res = await getCurrentUser();
      if (res) {
        setUser({ user: res });
        if (res.progress && res.progress.length) {
          setProgress(res.progress);
          checkCurrentLevel(res.progress);
        } else {
          if (!progress.length) {
            setProgress([
              {
                isWon: false,
                isInProgress: true,
                messages: [],
                symbols: 0,
                cluesUsed: 0,
                score: 0,
              },
            ]);
          }
          checkCurrentLevel(progress);
          await updateUserScore(getCommonScore());
        }
        navigate("/");
      } else {
        setError("Failed to load user data.");
      }
    } catch (err) {
      console.error("Magic link verification failed:", err);
      setError(err.message || "Invalid or expired link. Please request a new one.");
    }
  };

  if (error) {
    return (
      <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", height: "100vh", padding: "20px", textAlign: "center" }}>
        <Title level={3} style={{ color: "#ff4d4f" }}>⚠️ Link expired or invalid</Title>
        <p style={{ color: "#a0a0b0", fontSize: "16px", marginBottom: "24px" }}>{error}</p>
        <a href="/login" style={{ color: "#3C8618", fontSize: "16px" }}>← Back to login</a>
      </div>
    );
  }

  return <Loading />;
}

export default AuthVerify;
